import FormService from "../../services/FormService";
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import SelectPicker from '../../components/SelectPicker';
import FormInput from '../../components/FormInput';

export default {
    components: {Datepicker, SelectPicker, FormInput},
    data() {
        return {
            options: {
                format: 'Y-MM-DD H:mm',
                useCurrent: false,
                showClear: false,
                showClose: false,
                inline: false,
                icons: {
                    time: 'mdi mdi-timer',
                    date: 'mdi mdi-timetable',
                    up: 'mdi mdi-chevron-up',
                    down: 'mdi mdi-chevron-down',
                    previous: 'mdi mdi-chevron-left',
                    next: 'mdi mdi-chevron-right',
                    today: 'mdi mdi-calendar-today',
                    clear: 'mdi mdi-delete',
                    close: 'mdi mdi-close-box'
                }
            },
            routes: [],
            transporters: [],
            stations: [],
            buses: [],
            tariffs: [],
            form: new FormService({
                route_id: null,
                number: '',
                trip_regularity_type: 1,
                begin_at: this.$moment().format(),
                finish_at: this.$moment().add(1, 'months').format(),
                transporter_id: null,
                bus_id: null,
                tariff_id: null,
                driver_id: '',
                auto_generate: true,
                is_international: false,
                days: [],
                schedule_trip_details: [],
                schedule_trip_prices: {},
                comment: '',
                payment_calculation_type: 1,
                price: 0
            }),
            begin_at: this.$moment().format(),
            customDays: '',
            customDaysError: '',
            driver: '',
            added_days: [],
            departure_times: [],
            arrival_times: [],
            wait_times: [],
            platform: [],
            monthRegularityType: 1,
            id: null,
            calculation_types: [],
            currentRoute: {},
            schedule_trip_prices: [],
            price_for_save: [],
            loading_items: 0,
            is_loading: false
        }
    },
    created() {
        this.is_loading = true;
        this.$api.get('routes.all')
            .then(res => {
                this.routes = res.data;
                this.loading_items++;
            });
        this.$api.get('transporters.index')
            .then(res => {
                this.transporters = res.data;
                this.loading_items++;
            });
        this.$api.get('tariff.all')
            .then(res => {
                this.tariffs = res.data;
                this.loading_items++;
            });
        this.$api.get('schedule-trips.regularity-types')
            .then(res => {
                this.$store.commit('setRegularityTypes', res.data);
                this.loading_items++;
            });
        this.$api.get('schedule-trips.calculation')
            .then(res => {
                this.calculation_types = res.data;
                this.loading_items++;
            });
    },
    mounted() {
    },
    methods: {
        getSchedule() {
            let id = this.$route.params['id'];
            if (id) {
                this.id = id;
                this.$api.get('schedule-trips.show', id)
                    .then(res => {
                        let data = res.data;
                        let form = this.form;

                        form.route_id = data.route_id;
                        form.number = data.route.number;
                        form.trip_regularity_type = data.trip_regularity_type;
                        form.days = data.days;
                        form.begin_at = data.begin_at;
                        form.finsih_at = data.finish_at;
                        form.transporter_id = data.bus.transporter_id;
                        form.bus_id = data.bus_id;
                        form.driver_id = data.bus.driver_id;
                        form.auto_generate = data.auto_generate;
                        form.is_international = data.is_international;
                        form.schedule_trip_details = data.schedule_trip_details;
                        form.comment = data.comment;

                        this.begin_at = data.begin_at;
                        this.driver = data.bus.driver.name;
                        this.handleRouteChange(false);
                        this.handleTransporterChange();
                        this.recalculateTimes();
                    })
            }
        },
        recalculateTimes() {
            let now = this.$moment(this.begin_at).unix() * 1000;
            this.form.schedule_trip_details.forEach(item => {
                this.arrival_times.push(this.$moment(now + item.estimated_time_of_arrival * 1000).format('HH:mm'));
                this.departure_times.push(this.$moment(now + item.estimated_time_of_departure * 1000).format('HH:mm'));
                this.wait_times.push((item.estimated_time_of_departure - item.estimated_time_of_arrival) / 60);
                this.platform.push(item.platform);
            });
            this.begin_at = this.$moment(now).format('Y-MM-DD');
        },
        handleRouteChange(clear = true) {
            let route = this.routes.find(item => item.id === this.form.route_id);
            this.form.number = route ? route.number : '';
            this.stations = route ? route.routes_stations : [];
            this.currentRoute = route;
            this.calculatePrices();
            if (clear) this.clearRouteTimes();
        },
        handleTransporterChange() {
            let transporter = this.transporters.find(item => item.id === this.form.transporter_id);
            this.buses = transporter ? transporter.buses : [];
        },
        handleBusChange() {
            let bus = this.buses.find(item => item.id === this.form.bus_id);
            this.driver = bus ? bus.driver.name : '';
            this.form.driver_id = bus ? bus.driver.id : '';
        },
        handleRegularityType() {
            switch (this.form.trip_regularity_type) {
                case 1:
                    this.form.days = null;
                    break;
                case 2:
                    this.form.days = 2;
                    break;
                case 3:
                    this.form.days = [];
                    break;
                case 4:
                    this.form.days = {
                        type: 1,
                        days: []
                    };
                    break;
                case 5:
                    this.form.days = [];
            }
        },
        splitDays() {
            let days = this.customDays;
            let byComma = days.split(',');
            let daysArray = [];
            let byDash = [];
            byComma.forEach(item => {
                let dash = item.indexOf('-');
                if (dash >= 0) {
                    byDash = item.split('-');
                    let first = parseInt(byDash[0]);
                    let second = parseInt(byDash[1]);
                    if (first > 0 && second > 0) {
                        if (first < second)
                            for (let i = first; i <= second; i++)
                                daysArray.push(i);
                        else
                            for (let i = second; i <= first; i++)
                                daysArray.push(i);
                    } else {
                        if (first > 0) daysArray.push(first);
                        if (second > 0) daysArray.push(second);
                    }
                } else {
                    daysArray.push(parseInt(item));
                }
            });
            daysArray = daysArray.filter((v, i, a) => a.indexOf(v) === i);
            daysArray.sort((a, b) => {
                return a - b
            });
            this.form.days.days = daysArray;
        },
        addDate() {
            this.form.days.push(this.$moment().format());
        },
        removeDate(i) {
            this.form.days.splice(i, 1);
        },
        calculateTimes() {
            let details = [];
            let last_d = 0;
            let sum = 0;
            this.begin_at = this.$moment(this.begin_at).format('Y-MM-DD');
            this.stations.forEach((item, key) => {
                details.push({
                    routes_station_id: item.id,
                    platform: this.platform[key]
                });
                let a_date = new Date(this.arrival_times[key] ? this.arrival_times[key] : this.departure_times[key]);
                let d_date = new Date(this.departure_times[key] ? this.departure_times[key] : this.arrival_times[key]);
                let a_time = this.$moment(a_date).unix();
                let d_time = this.$moment(d_date).unix();
                if (key === 0) {
                    last_d = a_time;
                }
                this.wait_times[key] = ((d_time - a_time) / 60) || '';
                let arrival_time = a_time - last_d;
                let departure_time = d_time - a_time;
                sum += arrival_time;
                details[key].estimated_time_of_arrival = sum;
                sum += departure_time;
                details[key].estimated_time_of_departure = sum;
                details[key].platform = this.platform[key];
                last_d = d_time;
            });
            this.form.schedule_trip_details = details;
        },
        save(redirect = false) {
            try {
                /*this.form.begin_at = this.departure_times[0] ?
                    this.departure_times[0] :
                    this.$moment(this.begin_at).format('DD.MM.Y');*/

                this.form.begin_at = this.$moment(this.begin_at).format('Y-MM-DD') + " " + this.getDepartureTime();

                this.setTripPrice();
                this.form.price = this.schedule_trip_prices[0][this.schedule_trip_prices[0].length - 1];
                this.form.schedule_trip_prices.price = this.price_for_save;

                if (this.id) {
                    this.update(redirect);
                } else {
                    this.create(redirect);
                }
            } catch (error) {
                console.log(error)
            }
        },
        create(redirect) {
            this.form.post('schedule-trips.create')
                .then(res => {
                    if (!res.errors) {
                        if (redirect) {
                            this.$router.push({name: 'schedules'});
                        }
                        this.successNotify();
                    }
                })
        },
        update(redirect) {
            this.form.put('schedule-trips.update', this.id)
                .then(res => {
                    if (!res.errors) {
                        if (redirect) {
                            this.$router.push({name: 'schedules'});
                        }
                        this.successNotify();
                    }
                })
        },
        successNotify() {
            this.$notify({
                type: 'success',
                group: 'foo',
                title: this.i18n('Successfully!!!'),
                text: this.i18n('Saved!')
            });
        },
        clearRouteTimes() {
            this.added_days = [];
            this.departure_times = [];
            this.arrival_times = [];
            this.wait_times = [];
            this.platform = [];
            this.form.schedule_trip_details = [];
        },
        calculatePrices() {
            let tariff = this.tariffs.find(item => item.id === this.form.tariff_id);
            let t_price = tariff ? parseInt(tariff.price_per_km) : 0;
            let per_price = 0;
            for (let i = 0; i < this.stations.length; i++) {
                per_price = 0;
                if (i < this.stations.length - 1) {
                    this.schedule_trip_prices[i] = [];
                    for (let j = 0; j < this.stations.length; j++) {
                        if (j > i) {
                            per_price += parseInt(this.stations[j].distance) * t_price;
                            this.schedule_trip_prices[i][j] = per_price;
                        }
                    }
                }
            }
            this.$forceUpdate();
        },
        setTripPrice() {
            this.price_for_save = [];
            for (let i = 0; i < this.stations.length; i++) {
                if (i < this.stations.length - 1) {
                    for (let j = 0; j < this.stations.length; j++) {
                        if (j > i) {
                            if (this.schedule_trip_prices[i][j] > 0) {
                                this.price_for_save.push({
                                    from: this.stations[i].station_id,
                                    to: this.stations[j].station_id,
                                    price: parseInt(this.schedule_trip_prices[i][j])
                                });
                            }
                        }
                    }
                }
            }
        },
        getDepartureTime() {
            let date = new Date(this.departure_times[0]);
            let hour = date.getHours();
            let min = date.getMinutes();
            return (hour < 10 ? "0" + hour : hour) + ":"
                + (min < 10 ? "0" + min : min)
        },
        asTime(val) {
            let hour = Math.floor(val / 60 / 60);
            let min = Math.floor(val / 60 % 60);
            return hour + ' ' + this.i18n('h') + ' ' + min + ' ' + this.i18n('min')
        }
    },
    computed: {
        arrivalTime() {
            return (this.form.schedule_trip_details[this.form.schedule_trip_details.length - 1] || {estimated_time_of_arrival: ''}).estimated_time_of_arrival || 0;
        },
    },
    filters: {
        asTime(val) {
            let hour = Math.floor(val / 60 / 60);
            let min = Math.floor(val / 60 % 60);

            return hour + ' ч ' + min + ' мин'
            // return val
        }
    },
    watch: {
        routes: function () {
            this.getSchedule();
        },
        "form.payment_calculation_type": function (val) {
            if (val === 1) {
                this.calculatePrices();
            }
        },
        "form.tariff_id": function (val) {
            this.calculatePrices();
        },
        loading_items(new_value, old_value, val) {
            if (new_value === 5) {
                this.is_loading = false
            }
        }
    }
}
